export const invalidEmailError = 'Please enter a valid email.';
export const emailExistsError = 'An account with that email already exists.';
export const noPasswordError = 'Please enter your current password.';
export const passwordMatchError = 'The two passwords you entered do not match.';
export const passwordUnchangedError = 'New password must differ from old password.';
export const wrongPasswordError = 'Incorrect password. Please try again.';
export const genericServerError = 'There was a problem with your request. Please try again.';
